import { coursegroupsApi } from "api/coursegroups/coursegroupsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useCourseGroups = (skip: number, limit: number, filter: string = "", orderBy: string = "") => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_GROUPS(skip, limit, filter, orderBy),
    queryFn: () => coursegroupsApi.fetch(skip, limit, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_GROUPS(skip, limit, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, courseGroups: data?.data.data ?? [], total: data?.data.total ?? 0 };
};
